







































import Vue from 'vue'
import iconClose from '@/assets/svg/rounded/close.svg?inline'

export interface Option {
  [key: string]: string
}

interface Props {
  option: Option[]
  keyName: string
  tagName: string
  defaultSelect: string[]
}

interface Data {
  inputValue: string
  selectedOption: Option[]
  show: boolean
}

interface Methods {
  changeSelectedOption: (item: Option) => void
  setInputFocus: () => void
  showOptions: () => void
  hideOptions: () => void
  isActive: (tag: Option) => boolean
  deleteOption: () => void
  setSelectedOption: () => void
}

interface Computed {
  filteredOption: Option[]
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    iconClose,
  },
  props: {
    option: {
      required: true,
    },
    keyName: {
      required: true,
    },
    tagName: {
      required: true,
    },
    defaultSelect: {
      required: true,
    },
  },
  data() {
    return {
      inputValue: '',
      selectedOption: [],
      show: false,
    }
  },
  methods: {
    changeSelectedOption(item) {
      const index = this.selectedOption.map(elem => elem.id).indexOf(item.id)
      if (index !== -1) {
        this.selectedOption.splice(index, 1)
      } else {
        this.selectedOption.push(item)
      }
      this.inputValue = ''
      this.$emit('input', this.selectedOption)
    },
    showOptions() {
      this.show = true
    },
    hideOptions() {
      this.show = false
    },
    setInputFocus() {
      ;(this.$refs.inputRef as HTMLElement).focus()
    },
    isActive(tag) {
      return this.selectedOption.map(elem => elem.id).includes(tag.id)
    },
    deleteOption() {
      if (!this.inputValue.length) {
        this.selectedOption.pop()
      }
    },
    setSelectedOption() {
      if (this.defaultSelect.length && this.option) {
        this.selectedOption = this.option.filter(elem => {
          return this.defaultSelect.includes(elem[this.keyName])
        })
        this.$emit('input', this.selectedOption)
      }
    },
  },
  computed: {
    filteredOption() {
      return this.option.filter(elem => {
        return elem[this.tagName]
          .toLowerCase()
          .includes(this.inputValue.toLowerCase())
      })
    },
  },
  mounted() {
    this.setSelectedOption()
  },
})
